import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22font.config.ts%22,%22import%22:%22Noto_Sans_Arabic%22,%22arguments%22:[{%22subsets%22:[%22arabic%22],%22variable%22:%22--font-noto-sans-arabic%22}],%22variableName%22:%22fontNotoSansArabic%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Noto Sans Arabic', 'Noto Sans Arabic Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
